"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCKED_TASK_TYPE = exports.TASK_TYPE = void 0;
exports.TASK_TYPE = {
    ARCHIVE_CAMPAIGNS_WITHOUT_SALES: 'ARCHIVE_CAMPAIGNS_WITHOUT_SALES',
    BUILD_SITE: 'BUILD_SITE',
    BUILD_GATSBY_SITE: 'BUILD_GATSBY_SITE',
    BUILD_AUTORESPONDER_PREVIEW: 'BUILD_AUTORESPONDER_PREVIEW',
    CHARGE_SUBSCRIPTION: 'CHARGE_SUBSCRIPTION',
    CANCEL_FULFILLMENT: 'CANCEL_FULFILLMENT',
    CANCEL_SUBSCRIPTION_AFTER_NEXT_MONTH: 'CANCEL_SUBSCRIPTION_AFTER_NEXT_MONTH',
    CHECK_AMAZON_EXPIRING_CERTIFICATES: 'CHECK_AMAZON_EXPIRING_CERTIFICATES',
    CHECK_CART_STATUS: 'CHECK_CART_STATUS',
    CHECK_ORDER_STATUS: 'CHECK_ORDER_STATUS',
    CLEAR_CACHE_TABLES: 'CLEAR_CACHE_TABLES',
    CREATE_PRODUCTS_FEEDS: 'CREATE_PRODUCTS_FEEDS',
    CONVERT_TASKS_TO_JOBS: 'CONVERT_TASKS_TO_JOBS',
    CREATE_VIRTUAL_PRODUCT: 'CREATE_VIRTUAL_PRODUCT',
    DELETE_PRODUCTS_FROM_EXTERNAL_SHOP_FEED: 'DELETE_PRODUCTS_FROM_EXTERNAL_SHOP_FEED',
    PROCESS_ORDER: 'PROCESS_ORDER',
    PROCESS_PRODUCT_IN_FULFILLMENT: 'PROCESS_PRODUCT_IN_FULFILLMENT',
    DEPLOY_LANDING: 'DEPLOY_LANDING',
    DEPLOY_GATSBY_LANDING: 'DEPLOY_GATSBY_LANDING',
    DOWNLOAD_AMAZON_CERTIFICATES: 'DOWNLOAD_AMAZON_CERTIFICATES',
    DULICATE_FULFILLMENT: 'DULICATE_FULFILLMENT',
    DUPLICATE_LANDING: 'DUPLICATE_LANDING',
    DUPLICATE_QUIZ: 'DUPLICATE_QUIZ',
    DUPLICATE_FULFILLMENT: 'DUPLICATE_FULFILLMENT',
    GET_ORDER_TRACKING_NUMBER: 'GET_ORDER_TRACKING_NUMBER',
    GENERATE_CHARGE_SUBSCRIPTION_TASKS: 'GENERATE_CHARGE_SUBSCRIPTION_TASKS',
    HANDLE_SHIPSTATION_SHIPPING_NOTIFY: 'HANDLE_SHIPSTATION_SHIPPING_NOTIFY',
    HANDLE_CUSTOM_GATEWAY_SHIPPING_NOTIFY: 'HANDLE_CUSTOM_GATEWAY_SHIPPING_NOTIFY',
    IMPORT_EMAILS: 'IMPORT_EMAILS',
    ARCHIVE_LANDING: 'ARCHIVE_LANDING',
    RENEW_LANDING_SSL: 'RENEW_LANDING_SSL',
    REQUEST_AWS_CERTIFICATE: 'REQUEST_AWS_CERTIFICATE',
    REMOVE_CUSTOMER_FROM_SENDGRID: 'REMOVE_CUSTOMER_FROM_SENDGRID',
    SEND_AUTO_CREATED_CUSTOMER_ACCOUNT_EMAIL: 'SEND_AUTO_CREATED_CUSTOMER_ACCOUNT_EMAIL',
    SEND_DOUBLE_OPT_IN_EMAIL: 'SEND_DOUBLE_OPT_IN_EMAIL',
    SEND_ORDER_CANCELLATION_EMAIL: 'SEND_ORDER_CANCELLATION_EMAIL',
    SEND_ORDER_PARTIAL_REFUND_EMAIL: 'SEND_ORDER_PARTIAL_REFUND_EMAIL',
    SEND_ORDER_TO_FULFILLMENT: 'SEND_ORDER_TO_FULFILLMENT',
    REDEPLOY_CAMPAIGN_LANDINGS: 'REDEPLOY_CAMPAIGN_LANDINGS',
    SEND_CUSTOM_TEXT_EMAIL: 'SEND_CUSTOM_TEXT_EMAIL',
    SEND_ORDER_CONFIRMATION_EMAIL: 'SEND_ORDER_CONFIRMATION_EMAIL',
    SEND_PARTIAL_ORDER_EMAIL: 'SEND_PARTIAL_ORDER_EMAIL',
    SEND_PARTIAL_ORDER_EMAIL_2: 'SEND_PARTIAL_ORDER_EMAIL_2',
    SEND_PRODUCT_TO_EXTERNAL_SHOP_FEED: 'SEND_PRODUCT_TO_EXTERNAL_SHOP_FEED',
    SEND_REQUEST_SUPPORT_EMAIL: 'SEND_REQUEST_SUPPORT_EMAIL',
    SEND_REQUEST_SUPPORT_EMAIL_V2: 'SEND_REQUEST_SUPPORT_EMAIL_V2',
    SEND_SHIPPING_CONFIRMATION_EMAIL: 'SEND_SHIPPING_CONFIRMATION_EMAIL',
    SEND_SUBSCRIPTION_CANCELLATION_EMAIL: 'SEND_SUBSCRIPTION_CANCELLATION_EMAIL',
    SEND_SURVEY_EMAIL: 'SEND_SURVEY_EMAIL',
    SEND_VIP_CLUB_CONFIRMATION_EMAIL: 'SEND_VIP_CLUB_CONFIRMATION_EMAIL',
    SEND_VIP_LOGIN_EMAIL: 'SEND_VIP_LOGIN_EMAIL',
    SEND_VIP_PRE_BILLING_EMAIL: 'SEND_VIP_PRE_BILLING_EMAIL',
    SEND_VIP_PRE_BILLING_MONTHLY_EMAIL: 'SEND_VIP_PRE_BILLING_MONTHLY_EMAIL',
    SEND_VIP_CANCELLATION_EMAIL: 'SEND_VIP_CANCELLATION_EMAIL',
    SEND_USER_CONFIRMATION_EMAIL: 'SEND_USER_CONFIRMATION_EMAIL',
    SEND_SUBSCRIPTION_WELCOME_EMAIL: 'SEND_SUBSCRIPTION_WELCOME_EMAIL',
    SEND_WELCOME_EMAIL_2: 'SEND_WELCOME_EMAIL_2',
    // TODO UPLOAD_ARTWORK will be legacy type after all tasks of this type will be finished
    UPLOAD_ARTWORK: 'UPLOAD_ARTWORK',
    UPDATE_CAMPAIGN_LANDINGS_FROM_TEMPLATE: 'UPDATE_CAMPAIGN_LANDINGS_FROM_TEMPLATE',
    UPDATE_LANDING_FROM_TEMPLATE: 'UPDATE_LANDING_FROM_TEMPLATE',
    UPDATE_ORDER_IN_FULFILLMENT: 'UPDATE_ORDER_IN_FULFILLMENT',
    UPDATE_SUBSCRIPTIONS_DATA: 'UPDATE_SUBSCRIPTIONS_DATA',
    HANDLE_AUTHORIZE_PAYMENT_TRANSACTION: 'HANDLE_AUTHORIZE_PAYMENT_TRANSACTION',
    HANDLE_AUTHORIZE_REFUND_TRANSACTION: 'HANDLE_AUTHORIZE_REFUND_TRANSACTION',
    HANDLE_STRIPE_REFUND_TRANSACTION: 'HANDLE_STRIPE_REFUND_TRANSACTION',
    HANDLE_STRIPE_INVOICE_PAID: 'HANDLE_STRIPE_INVOICE_PAID',
    HANDLE_PAYPAL_REFUND_TRANSACTION: 'HANDLE_PAYPAL_REFUND_TRANSACTION',
    SEND_PARTIAL_OPT_IN_SMS: 'SEND_PARTIAL_OPT_IN_SMS',
    SEND_WELCOME_ORDER_SMS: 'SEND_WELCOME_ORDER_SMS',
    SEND_EMAIL: 'SEND_EMAIL'
};
exports.LOCKED_TASK_TYPE = [exports.TASK_TYPE.DUPLICATE_FULFILLMENT, exports.TASK_TYPE.SEND_ORDER_TO_FULFILLMENT, exports.TASK_TYPE.PROCESS_ORDER];
//# sourceMappingURL=taskType.js.map